import {
    URL_DOMAIN,
    URL_HELP,
    URL_DOMAIN_MARKET,
    getJSON,
    URL_P2,
    URL_SALES,
    requestOptionsGet,
    requestOptionsPost,
    requestOptionsPut
  } from "../globals";

  const URL_FINAL = URL_DOMAIN + URL_P2[2];

const URL_PRODUCT = URL_DOMAIN + URL_P2[2];


const supervisorId = localStorage.getItem("fk_supervisor");

const organizationId = localStorage.getItem('fk_organization');
/**
 * Franchises
 * @returns
 */

const postService = async (formData) => {
    requestOptionsPost.body = formData;
    return fetch(URL_DOMAIN + "service/create-service", requestOptionsPost).then(
      getJSON
    );
  };

const getServicesOfOrganization = async () => {
  try {
    const response = await fetch(
      URL_DOMAIN +
      "service/get-all-services-of-organization?fk_organization=" +
      organizationId,
      requestOptionsGet
    );

    if (!response.ok) {
      throw new Error("Error al obtener los datos de ventas");
    }

    return getJSON(response);
  } catch {
    throw new Error("Error al obtener los datos de ventas: ");
  }
};

const getServiceById = async (id) => {
  return fetch(
    URL_DOMAIN + "service/get-service-detail?fk_product=" + id,
    requestOptionsGet
  ).then(getJSON);
};

const putService = async (formData) => {
  requestOptionsPut.body = formData;
  return fetch(URL_DOMAIN + "service/edit-service", requestOptionsPut).then(
    getJSON
  );
};

export { postService, getServicesOfOrganization, getServiceById, putService };